//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ajaxGetDictItems } from '@/api/api';
export default {
  data: function data() {
    return {
      typeList: [],
      selectCt: '',
      searchValue: ''
    };
  },
  created: function created() {
    this.getTypeList();
  },
  methods: {
    getTypeList: function getTypeList() {
      var _this = this;

      ajaxGetDictItems('company_type', null).then(function (res) {
        if (res.success) {
          _this.typeList = res.result;

          _this.selectItem(_this.typeList[0]);
        }
      });
    },
    selectItem: function selectItem(item) {
      if (this.selectCt == item.value) {
        this.selectCt = '';
      } else {
        this.selectCt = item.value;
      }

      this.$emit('selectCompanyType', this.selectCt);
    },
    submit: function submit() {
      this.$emit('searchSite', this.searchValue);
    }
  }
};